import { InsuranceEntryState } from 'domains/signupv2/Insurance/insuranceMachineV2';
import { SignupState } from 'domains/signupv2/Parent/signupMachineV2';
import { ScheduleState } from 'domains/signupv2/schedule/scheduleMachineV2';
import mixpanel from 'mixpanel-browser';
import { MiniScreenerEntryState } from '../Mini-Screener/miniScreenerMachine';

const SIGNUP_EVENT_PREFIX = 'Viewed - Sign up Flow 4.0 -';

const TRACKED_SIGNUP_STATES: {
  [k in SignupState | InsuranceEntryState | ScheduleState | MiniScreenerEntryState]?: string;
} = {
  enterTarget: 'Client type (child/adult)',

  // contact info
  enterState: 'State',
  enterName: 'Name',
  enterPhoneNumber: 'Phone',
  enterEmail: 'Email',

  // insurance info
  enterUseInsurance: 'Use insurance?',
  enterInsuranceType: 'Insurance Type',
  enterMedicaidProvider: 'Medicaid Provider',
  insuranceNotInNetwork: 'Insurance not in network',

  // miniscreener info
  enterDob: 'Date of Birth',
  enterClientName: 'Client name (child/other-adult flow)',
  enterConcerns: 'Communication concerns',

  // consultation schedule
  enterConsultationDate: 'Schedule free consultation',
  confirmConsultationDate: 'Confirm Schedule',

  // internal states
  creatingLead: 'Creating lead (dev)',
  leadCreationError: 'Lead creation failed (dev)',
  loadingAvailableDates: 'Loading schedule dates (dev)',
  loadingDatesFailed: 'Loading schedule dates failed (dev)',
  schedulingConsultation: 'Saving consultation schedule (dev)',
  signupComplete: 'Signup complete, redirecting (dev)',
};

export const signupV2StateChangeListener = (
  currentState: SignupState | InsuranceEntryState | ScheduleState | MiniScreenerEntryState,
) => {
  const mappedEvent = TRACKED_SIGNUP_STATES[currentState];

  if (mappedEvent) {
    mixpanel.track(`${SIGNUP_EVENT_PREFIX} ${mappedEvent}`);
  }
};
